"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdGroupKeywordSelector = exports.applePaginatedDownload = exports.applePostPaginatedDownload = void 0;
const PAGINATION_LIMIT = 100;
function hasMoreData(pagination) {
    if (pagination && pagination.itemsPerPage && pagination.totalResults) {
        const read = (pagination.startIndex ?? 0) + pagination.itemsPerPage;
        return read < pagination.totalResults;
    }
    return false;
}
async function paginateDownload(fetcher, offset = 0, limit = PAGINATION_LIMIT, maxResults = Infinity) {
    let currentOffset = offset;
    let lastResponse = null;
    do {
        const response = await fetcher(currentOffset, limit);
        if (!response || !response.data) {
            throw new Error("Failed to retrieve data.");
        }
        const hasMore = hasMoreData(response.pagination);
        const responseSize = response.data.length;
        response.data = (lastResponse?.data || []).concat(response.data);
        response.pagination = {
            itemsPerPage: response.data.length,
            startIndex: offset,
            totalResults: Math.max(response.data.length, response.pagination?.totalResults ?? 0),
        };
        lastResponse = response;
        if (!hasMore) {
            return lastResponse;
        }
        currentOffset += responseSize;
    } while (currentOffset < maxResults);
    return lastResponse;
}
async function applePostPaginatedDownload(fetcher, body, offset = 0, limit = PAGINATION_LIMIT, maxResults = Infinity) {
    return paginateDownload((o, l) => fetcher({ ...body, pagination: { offset: o, limit: l } }), offset, limit, maxResults);
}
exports.applePostPaginatedDownload = applePostPaginatedDownload;
async function applePaginatedDownload(fetcher, query, offset = 0, limit = PAGINATION_LIMIT, maxResults = Infinity) {
    return paginateDownload((o, l) => fetcher({ ...query, offset: o, limit: l }), offset, limit, maxResults);
}
exports.applePaginatedDownload = applePaginatedDownload;
function getAdGroupKeywordSelector(adGroupRef) {
    return {
        conditions: [
            {
                field: "adGroupId",
                operator: "IN",
                values: [adGroupRef],
            },
        ],
        orderBy: [
            {
                field: "id",
                sortOrder: "ASCENDING",
            },
        ],
    };
}
exports.getAdGroupKeywordSelector = getAdGroupKeywordSelector;
